import { type ButtonHTMLAttributes, type CSSProperties, type ReactNode } from 'react';
import ButtonLoadingIcon from '../../assets/icons/ButtonLoadingIcon';
import { FlexCenter } from '../modal/styles';
import { ButtonContainer, IconContainer } from './styles';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'formAction'> {
  children: ReactNode;
  style?: CSSProperties;
  loading?: boolean;
  icon?: React.ReactNode;
  roundedIcon?: boolean;
  disabled?: boolean;
  color?: 'primary' | 'secondary';
}

const Button = ({
  children,
  style,
  loading = false,
  disabled = false,
  color = 'primary',
  roundedIcon,
  onClick,
  icon,
  ...rest
}: ButtonProps) => {
  return (
    <ButtonContainer
      style={style}
      onClick={(event) => {
        if (!disabled && !loading && onClick) onClick(event);
      }}
      $loading={Boolean(loading)}
      $disabled={disabled}
      $color={color}
      {...rest}
    >
      {loading && <ButtonLoadingIcon style={{ width: '20px', marginRight: '6px' }} />}
      <FlexCenter gap={6}>
        {icon && <IconContainer $rounded={roundedIcon}>{icon}</IconContainer>}
        {children}
      </FlexCenter>
    </ButtonContainer>
  );
};

export default Button;
